"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Container handler for @index.
 *
 * This will ignore the current key and add this entry to the parent node.
 */
class ContainerHandlerIndex {
    async handle(parsingContext, keys, value, depth) {
        await parsingContext.newOnValueJob(keys, value, depth - 1);
    }
}
exports.ContainerHandlerIndex = ContainerHandlerIndex;
//# sourceMappingURL=ContainerHandlerIndex.js.map